import {Fonts} from "@/constants/font";
import BBCodeText from "phaser3-rex-plugins/plugins/bbcodetext";
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import {EventRewardDto, EventRewardPosition, EventRewardType} from "@/store/task/types";
import {Tr} from "@/i18n/i18n";
import TextUtils, {FontsKeys, TextAlign} from "@/utils/text-utils";
import {ChestType} from "@/store/player/types";

export class ListEventInfoPanel extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, positions: EventRewardPosition[], openRatingCallback: () => void){
        super(scene);

        this.scene = scene;
        this.height = 1000;

        const back = SpriteUtils.addImage(this.scene, -300, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, this.height);

        this.add(back);

        let text = "\n\n\n";
        positions.forEach(p =>{
            if(p.from == p.to){
                text += `   [color=#e0a141]${Tr('place')} ${p.from+1} - [/color]`;
            }
            text += `   [color=#e0a141]${Tr('places')} ${Tr('from')} [color=#ff6e82]${p.from}[/color] [color=#e0a141]${Tr('to')}[/color] [color=#ff6e82]${p.to}[/color] - [/color]`;
            p.rewards.forEach(r => {
                text += this.getRewardDesc(r) + ", ";
            })
            text = text.slice(0, -2);
            text += "\n\n";

        })

        let contentText = new BBCodeText(scene, -280 * CU.S, 0, text, {
            fontFamily: Fonts.MYRIADPRO_REGULAR,
            fontSize: '14pt',
            wrap: {
                mode: 1,
                width: 560
            }
        }).setScale(CU.S, CU.S);

        let ratingButton = SpriteUtils.addSprite(this.scene, 0 / CU.S, contentText.getBottomLeft().y! / CU.S + 30, Keys.ATLAS_UI, Keys.UI_BUTTON_BROWN_SMALL, 0.8, 0.6);
        // ratingButton.alpha = 0.5;
        ratingButton.setInteractive().on('pointerup', () => {
            openRatingCallback();
        });

        let ratingText = TextUtils.addBMText(scene, Tr('reyting').toUpperCase(), 0, contentText.getBottomLeft().y! / CU.S + 30, 16, 100,
            TextAlign.CENTER, 1, FontsKeys.COINY)
        ratingText.setTintFill(0xffffff);
        ratingText.alpha = 0.5;

        this.add([contentText, ratingButton, ratingText]);
    }

    private getRewardDesc(reward: EventRewardDto ){
        switch (reward.type) {
            case EventRewardType.GEMS:
                return '[color=#1effd5]' + reward.value + " " + Tr('izumrudov') + '[/color]';
            case EventRewardType.CHEST:
                for(let ct in ChestType) {
                    if(ct.toString() == reward.optionalId) {
                        switch (ct) {
                            case ChestType.AZURE:
                                return '[color=#ffcd17]' + Tr('az.chst') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value + '[/color]' : '');
                            case ChestType.LAVA:
                                return '[color=#ffcd17]' + Tr('lv.chst') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value + '[/color]' : '');
                            case ChestType.GOLD:
                                return '[color=#ffcd17]' + Tr('gld.chst') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value + '[/color]' : '');
                            case ChestType.AMBER:
                                return '[color=#ffcd17]' + Tr('amb.chst') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value + '[/color]' : '');
                            case ChestType.JADE:
                                return '[color=#ffcd17]' + Tr('jd.chst') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value + '[/color]' : '');
                            case ChestType.SILVER:
                        }
                        return '[color=#ffffff]' + Tr('slv.chst') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value +'[/color]' : '');
                    }
                }
            case EventRewardType.HERO1:
                return '[color=#d146ff]' + Tr('unique.hero.1') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value +'[/color]' : '');
            case EventRewardType.HERO2:
                return '[color=#d146ff]' + Tr('unique.hero.2') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value +'[/color]' : '');
            case EventRewardType.HERO3:
                return '[color=#d146ff]' + Tr('unique.hero.3') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value +'[/color]' : '');
        }
    }

}
